export default {
  id: 181,
  title: 'Target #181 - Iceland',
  url: 'https://cssbattle.dev/play/181',
  colors: ['#33499F', '#DE3832', '#FFFFFF'],
  solution:
    '<style>body{background:linear-gradient(90deg,transparent 125px,#DE3832 125px 175px,transparent 175px 190px),linear-gradient(transparent 110px,#fff 110px 125px,#DE3832 125px 175px,#fff 175px 190px,transparent 190px),linear-gradient(90deg,transparent 110px,#fff 110px 125px,#DE3832 125px 175px,#fff 175px 190px,transparent 190px)#33499F',
}
